// This solution was fount on http://beej.us/blog/data/javascript-gamepad/

export default function setDeadZone(value) {

    const DEADZONE = 0.2;

    // If stick value is smaller than dead zone, give it a value of 0
    // Math.abs() makes it work regardless of positive or negative value
    if (Math.abs(value) < DEADZONE) {

        return value = 0;

    } else {

        // We are outside the dead zone
        value = value - Math.sign(value) * DEADZONE;
        // Normalize the values between 0 and 1
        value /= (1.0 - DEADZONE);

        return value;

    }

}